const parse = require('falcor-path-syntax');

/**
 * Convert a Falcor route pattern into an array syntax path. Only suitable for leaf paths,
 * not query or routing expressions
 * @param {LeafPath<string>} path Route path expression to convert
 * @returns {LeafPath<Array>} the Converted array syntax path
 * @example
 * splitRoute('fx.pairs[0..3].bid');
 * // => ['fx', 'pairs', { from: 0, to: 3 }, 'bid']
 */
function splitRoute(path) {
  return parse(path, true);
}

module.exports = splitRoute;
